/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket } from '../../use-order-ticket'
import {
    showModal,
    hasSvc,
    getBrand,
    openWindow,
    fixURL,
    matIcon,
    iconLabel,
    Flyout,
    getOwaTcdaoContext,
} from '../../../twd'

export const AdditionalDetails = () => {
    const { bondInfo, orderInfo, isTreasuryAuction } = useOrderTicket()
    const issue = bondInfo.issue || {}
    const ask = (bondInfo.bestoffer || {}).ask || {}
    let docs = Documents.map(f => f({issue, ask, events:bondInfo.events, orderInfo, isTreasuryAuction})).filter(Boolean)
    if (docs.length===0) return null


    const holdInvType = bondInfo.issue && bondInfo.issue.type
    const hasTradeHistory = ['A','C','M'].indexOf(holdInvType)>=0


    return <React.Fragment>
    { !hasTradeHistory && <div className="row vertical-offset-xs"><div className="col-md-12"><hr aria-hidden={true} /></div></div> }

    <div className="row row vertical-offset-xs">
    <div className="col-xs-12">
        <Flyout
            label="Additional details"
            labelAttrs={{className:"h3"}}
            html={`
                As available, this section will populate with the following information pertaining to your bond:
                individual bond report provided by Moody’s Investor Service, disclosure documentation,
                material event information, depth of market, and prospectus/offering document.
                This information may be unavailable for certain securities.
                `}
        />
    </div>
    </div>
    <div className="row">
    <div className="col-xs-12">
        {
            docs
            .flatMap( (a,i) => [a, <Sep key={i} />])
            .slice(0, -1)
        }
    </div>
    </div>
    </React.Fragment>
}

const Sep = () => <span aria-hidden={true} style={{padding:'0 10px 0 10px'}}>|</span>

let Documents = [
    // factsheet
    ({issue, ask}) => {
        let f = hasSvc('FACT')
            && ['M','C'].indexOf(issue.type)>=0
            && issue.currencyCode === 'USD'
            && issue.floaterInd ==='N'
            && issue.linkedIndexInd ==='N'
        if (!f) return

        let sp = new URLSearchParams([
            ['p_id', ask.id || ''],
            ['p_type', issue.type || ''],
            ['p_cusip', issue.cusip || ''],
        ])

        let url = 'https://www.bonddesk.com/'
            + getBrand()
            + '/servlet/rtresult/factsheet.pdf?'
            + sp.toString()

        return <button
            key="document-1"
            data-name="order-ticket-factsheet-button"
            type="button"
            className='link-button'
            onClick={() => openWindow(url, '_blank') }
            >{ iconLabel(matIcon('picture_as_pdf'), 'Factsheet') } </button>
    },

    // moody rating
    ({issue, orderInfo}) => {
        let f1 = hasSvc('MDBR')
            && ['M','C','A','P'].indexOf(issue.type)>=0
            && issue.moodyRating
            && ['-', 'Nr', 'Nr-A', 'NR', 'WR', 'Wr'].indexOf(issue.moodyRating)<0
        let f2 = orderInfo.p_show_mdy_br === 'true'
        if (!f1 || !f2) return

        return <button
            key="document-2"
            data-name="order-ticket-moody-rating-button"
            type="button"
            className='link-button'
            onClick={() => openWindow(
                '/esb/moodysreport/getBondReport?cusip=' + issue.cusip,
                '_blank',
            )}
            >{ iconLabel(matIcon('picture_as_pdf'), "Moody's Bond Report") } </button>
    },

    // prospectus
    ({issue}) => {
        let { researchLinks } = issue
        const f = researchLinks
            && researchLinks.indexOf('"research"') > 0
            && (researchLinks.indexOf('LEGAL') > 0 || researchLinks.indexOf('SALES') > 0)
        if (!f) return

        const t = '"BDResearch.showViewer(\''
        const m = researchLinks.indexOf(t)
        if (m<0) return

        const n = m + t.length
        let url = researchLinks.slice(n, researchLinks.indexOf("');", m))
        if (!url) return
        let owaTcDaoContext = getOwaTcdaoContext()
        url ='https:/www.bonddesk.com/' + getBrand() + '/' + owaTcDaoContext + '/' + url

        return <button
            key="document-3"
            data-name="order-ticket-prospectus-button"
            type="button"
            className='link-button'
            onClick={() => openWindow(url, '_blank')}
            >{ iconLabel(matIcon('open_in_new'), 'Prospectus/Offering Document') }</button>
    },

    // emma
    ({issue}) => {
        let f = hasSvc('EMMA')
            && ['M'].indexOf(issue.type)>=0
            && issue.currencyCode==='USD'
        if (!f) return

        let url = fixURL('https://us.etrade.com/e/t/jumppage/viewjumppage?PageName=speedbump&comp=https%3A%2F%2Femma.msrb.org'
            + '%2FSecurityView%2FSecurityDetails.aspx%3Fcusip=' + issue.cusip)

        return <button
            key="document-4"
            data-name="order-ticket-emma-button"
            type="button"
            className='link-button'
            onClick={() => openWindow(url, '_blank')}
            >{ iconLabel(matIcon('open_in_new'), 'Disclosure info/EMMA') }</button>
    },

    // material-events
    ({issue, events}) => {
        let invType = issue.spInd==='Y' ? 'L' : issue.type
        let hasEvents = ['C', 'M', 'A', 'L'].indexOf(invType) >= 0
            && !(issue.type==='S' && issue.spInd==='Y' && issue.category==='N')
        if (!hasEvents) return

        let tab = invType === 'A' ? 'redemptions'
        : invType==='M' ? 'material-event-filings'
        : 'default-events'

        let lbl = invType === 'M' ? 'View all Material Events'
            : 'View all events'

    return <button
            key="document-5"
            data-name="order-ticket-material-events-button"
            className="link-button"
            onClick={(e) => {
                showModal({
                    view: 'events',
                    tab,
                    issue,
                    events,
                    from: 'bond-detail',
                    source: e.target,
                })
            }}>
        { iconLabel(matIcon('timeline'), lbl) }
        </button>
    },

    // depth of market
    ({issue, isTreasuryAuction}) => {
        if (!issue.showBook || isTreasuryAuction) return

        return <button
            key="document-6"
            data-name="order-ticket-depth-of-market-button"
            className="link-button"
            style={{minHeight:'20px'}}
            onClick={(e) => {
                showModal({
                    view: 'depth-of-market',
                    cusip: issue.cusip,
                    allowTrading: issue.allowTrading,
                    from: 'bond-detail',
                    source: e.target,
                })
            }}
            >
            {iconLabel(matIcon('layers'), 'Depth of Market')}
        </button>
    },

]



// WEBPACK FOOTER //
// ./src/order-ticket/snapshot/context/additional-details.js